import { LoadingOutlined } from '@ant-design/icons';
import { THEME } from '@common/constants/theme.constant';
import { Skeleton } from '@common/general-ui/skeleton/skeleton.component';
import { SerializedStyles } from '@emotion/react';
import { Spin } from 'antd';
import React, { ReactNode } from 'react';
import ReactDOM from 'react-dom';
import { css } from 'twin.macro';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

interface IProps {
    className?: string;
    isLoading: boolean;
    isFirstLoad?: boolean;
    children: JSX.Element | JSX.Element[] | ReactNode;
    name?: string;
}

const LoadingIcon = ({ isLoading, name }: Pick<IProps, 'isLoading' | 'name'>): JSX.Element => {
    return ReactDOM.createPortal(
        <>
            {isLoading && (
                <div css={styles.loadingIcon} data-testid={name ? 'spinner-' + name : 'loading-spinner'}>
                    <Spin indicator={antIcon} />
                </div>
            )}
        </>,
        document.getElementById('root') as HTMLElement,
    );
};

export const Loading = ({ className, isLoading, isFirstLoad, children, name }: IProps): JSX.Element => {
    return (
        <>
            <div css={styles.loading} className={className}>
                {isFirstLoad && isLoading ? (
                    <Skeleton />
                ) : (
                    <>
                        {children}
                        <div css={styles.panel(isLoading)}>
                            <LoadingIcon isLoading={isLoading} name={name} />
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

const styles = {
    loading: css`
        width: 100%;
        position: relative;
    `,

    panel: (loading: boolean): (SerializedStyles | boolean)[] => [
        loading &&
            css`
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;

                background: ${THEME.WHITE + 95};
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 998;
                cursor: wait;
            `,
    ],

    loadingIcon: css`
        position: fixed;
        left: 50%;
        top: 50vh;
        z-index: 999;
    `,
};
